import { throwError as observableThrowError, Observable } from "rxjs";
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";

import { map, catchError, tap } from "rxjs/operators";
import { environment } from "../../../../../environments/environment";
import { Utils } from "../../../../shared/Utils";

const contextPath = window.location.protocol + "//" + window.location.host;

@Injectable()
export class PlaceService {
  http: HttpClient;
  testMode: boolean;

  private httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
  };

  constructor(http: HttpClient, private utils: Utils) {
    this.http = http;
    this.testMode = environment.testMode;
  }

  validatePlace(placeDetails: any) {
    // if (this.testMode) {
    //   return Observable.of(environment.validatePlace);
    // }
    const url = contextPath + "/AddressValidation/v2/verifyAddress";
    this.utils.showLoading("validatePlace");
    return this.http.put(url, placeDetails, this.httpOptions).pipe(
      map((response) => this.extractData(response, true, "validatePlace")),
      catchError((error) => this.handleError(error, true, "validatePlace"))
    );
  }

  handleError(
    error: HttpErrorResponse,
    displayloading = true,
    callingMethodName: string = null
  ) {
    if (displayloading) {
      this.utils.closeLoading(callingMethodName);
    }
    return observableThrowError(error.error);
  }

  private extractData(
    res: HttpResponse<any> | any,
    displayloading = true,
    callingMethodName: string = null
  ) {
    if (displayloading) {
      this.utils.closeLoading(callingMethodName);
    }
    if (res && res.body) {
      return res.body;
    }
    return res;
  }

  checkOKResponse(
    res: HttpResponse<any>,
    displayloading = true,
    callingMethodName: string = null
  ) {
    if (displayloading) {
      this.utils.closeLoading(callingMethodName);
    }
    return 200 === res.status;
  }
}
